import { TranslationsMap } from 'marketing-site/lib/translation/buildTranslationsMap'
import { createContext } from 'react'

const TranslationsContext = createContext<TranslationsMap>(new Map<string, string>())
TranslationsContext.displayName = 'TranslationsContext'

export default TranslationsContext
